export enum ChannelType {
    //call_zandu = 'call_zandu',
    //wa_zandu = 'wa_zandu',
    wa_user = 'wa_user',
    wa_evo2_user = 'wa_evo2_user',
    wa_evo2_zandu = 'wa_evo2_zandu',
    wa_uazapi_user = 'wa_uazapi_user',
    wa_uazapi_zandu = 'wa_uazapi_zandu',
    waba_user = 'waba_user',
    voip_user = 'voip_user',
    call_user = 'call_user',
    //email_zandu = 'email_zandu',
    email_sendgrid = 'email_sendgrid',
    //sms_zandu = 'sms_zandu',
    sms_smsempresa = 'sms_smsempresa',
    email_gmail = 'email_gmail',
}

export enum ChannelTypeFriendly {
    //call_zandu = 'Torpedo de Voz - Zandu',
    //wa_zandu = 'WhatsApp - Zandu',
    wa_user = 'WhatsApp - App no computador',
    wa_evo2_zandu = 'WhatsApp - Servidor Zandu',
    wa_evo2_user = 'WhatsApp - Evolution API V2 (terceiros)',
    wa_uazapi_zandu = 'WhatsApp - Servidor Zandu (uazapi)',
    wa_uazapi_user = 'WhatsApp - uazapi (terceiros)',
    waba_user = 'WhatsApp Business API',
    voip_user = 'Telefonia VOIP',
    call_user = 'Celular Android',
    //email_zandu = 'E-Mail - Zandu',
    email_sendgrid = 'E-Mail - SendGrid (terceiros)',
    //sms_zandu = 'SMS - Zandu',
    sms_smsempresa = 'SMS - SMSEmpresa (terceiros)',
    email_gmail = 'E-Mail - Meu GMail',
}

export const ThirdPartyChannel = ['email_sendgrid', 'sms_smsempresa', 'call_user']
